import { toast } from "react-toastify";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { RootState } from "../..";
import { getCurrentUserId } from "Slices/currentUser";
import { updateStationConfirmation } from "Slices/stationConfirmation";
import API, { showNetworkErrorToast } from "Utils/api";

export const fetchGetStationVehiclesFromCurrentSemanticMap = createAsyncThunk(
  "stations/fetchGetStationVehiclesFromCurrentSemanticMap",
  async ({
    semanticMapId,
    // "isActive" is true by default which only fetches the Queued Missions that status
    // are not ["CANCELED", "FINISHED", "CANCEL_SENT", "CANCEL_PENDING", "FAILURE"]
    isActive = true,
  }: {
    semanticMapId: string;
    isActive?: boolean;
  }) => {
    try {
      const url = `stop_release_session/?semantic_map_id=${semanticMapId}${
        isActive ? `&is_active=${isActive}` : ""
      }`;
      const response = await API.get(url);
      return {
        stations: response.data.results ?? [],
        semanticMapId,
      };
    } catch (error) {
      showNetworkErrorToast(error);
      return Promise.reject();
    }
  }
);

export const fetchGetMissionsInQueueFromCurrentSemanticMap = createAsyncThunk(
  "stations/fetchGetMissionsInQueueFromCurrentSemanticMap",
  async ({ semanticMapId }: { semanticMapId: string }) => {
    try {
      const url = `fleets/mission_queue/?mission__semantic_map_id=${semanticMapId}`;
      const response = await API.get(url);
      return {
        missionsQueue: response.data.results ?? [],
        semanticMapId,
      };
    } catch (error) {
      showNetworkErrorToast(error);
      return Promise.reject();
    }
  }
);

export const fetchGetStationVehiclesFromCurrentSemanticMapAndStationId =
  createAsyncThunk(
    "stations/fetchGetStationVehiclesFromCurrentSemanticMapAndStationId",
    async ({
      semanticMapId,
      stationId,
      isActive = true, // see comments in line 13
    }: {
      semanticMapId: string;
      stationId: string;
      isActive?: boolean;
    }) => {
      try {
        const url = `stop_release_session/?semantic_map_id=${semanticMapId}&stop_id=${stationId}${
          isActive ? `&is_active=${isActive}` : ""
        }`;
        const response = await API.get(url);

        return {
          stations: response.data.results ?? [],
          semanticMapId,
          stationId,
        };
      } catch (error) {
        showNetworkErrorToast(error);
        return Promise.reject();
      }
    }
  );

export const fetchPatchVehicleConfirmation = createAsyncThunk<
  void,
  {
    button_id: number;
    session_id: string;
    version: number;
    successMessage: string;
  }
>(
  "stationConfirmation/fetchPatchVehicleConfirmation",
  async ({ button_id, session_id, version, successMessage }, thunkAPI) => {
    const currentUserId = getCurrentUserId(thunkAPI.getState() as RootState);
    const payload = {
      cloud_confirmations: [
        {
          button_id,
          confirmed: true,
          user_id: currentUserId,
        },
      ],
      version,
    };
    try {
      const response = await API.patch(
        `stop_release_session/${session_id}/`,
        payload
      );
      thunkAPI.dispatch(updateStationConfirmation(response.data));
      toast.success(successMessage);
    } catch (error) {
      showNetworkErrorToast(error);
      return Promise.reject();
    }
  }
);
